import * as React from "react";
import {cva} from "class-variance-authority";

import {cn} from "lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 font-sans uppercase tracking-[0.09em] text-kicker font-semibold",
  {
    variants: {
      variant: {
        // The kicker above a headline: colour alone, no chrome.
        kicker: "text-masthead",
        // A section tag with a rule under it, as on a print section front.
        section: "text-ink-tertiary",
        // Solid plate, used sparingly for live/breaking.
        plate: "rounded-sm bg-masthead px-1.5 py-0.5 text-masthead-foreground",
        // The recommender annotating the page.
        pencil:
          "rounded-sm border border-pencil/25 bg-pencil-muted px-1.5 py-0.5 text-pencil",
        outline: "rounded-sm border border-rule-strong px-1.5 py-0.5 text-ink-secondary",
      },
    },
    defaultVariants: {variant: "kicker"},
  }
);

function Badge({className, variant, ...props}) {
  return <span className={cn(badgeVariants({variant}), className)} {...props} />;
}

export {Badge, badgeVariants};
